import { useApp } from "@next-platform/client-common-core";
import { useApplicationCapabilitiesAllowed } from "@next-platform/client-common-core/infra/application/capabilities";
import { buildRulebookDiscoverFilter } from "@next-platform/client-common-core/rulebook/picker/rulebookDiscoverHit";
import { SubCapabilityKey } from "@next-platform/packages-ts-types";

import { NSFW_EXCLUSION_FILTER } from "@/constants";
import { Collection, TypesenseApiKey, TypesenseCollectionName } from "@/types/api";

/** Typesense filter: public Rulebooks of this app, without NSFW ones when the viewer filters them. */
export function createRulebookDiscoverFilters({ applicationId, shouldFilterNsfw }: { applicationId?: string; shouldFilterNsfw: boolean }): string {
  return buildRulebookDiscoverFilter({ applicationId, nsfwExclusionFilter: shouldFilterNsfw ? NSFW_EXCLUSION_FILTER : undefined });
}

/**
 * Whether the picker can offer Discover: `rulebook.publicDiscovery` allows it and the app is configured with the
 * public Rulebooks index. The index arrives with WS2D, so until its config keys exist the tab stays hidden.
 */
export function useRulebookDiscoverConfig(): { isAvailable: boolean; apiKey?: string; collectionName?: string } {
  const { typesenseConfig } = useApp();
  const isAllowed = useApplicationCapabilitiesAllowed(SubCapabilityKey.RulebookPublicDiscovery);
  const apiKey = typesenseConfig?.[TypesenseApiKey[Collection.RULEBOOKS]];
  const collectionName = typesenseConfig?.[TypesenseCollectionName[Collection.RULEBOOKS]];
  return { isAvailable: Boolean(isAllowed && apiKey && collectionName), apiKey, collectionName };
}
